import { useState } from "react";
import { Calendar } from "@/components/ui/calendar";
import { exportTradesCSV } from "@/utils/tradeUtils";

export default function TradebookToolbar({
  range,
  setRange,
  search,
  setSearch,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  groupBy,
  setGroupBy,
  trades,
}) {
  // Local calendar range state
  const [calendarRange, setCalendarRange] = useState();
  const [calendarOpen, setCalendarOpen] = useState(false);

  return (
    <div className="mb-4 space-y-3">
      {/* Search */}
      <input
        type="text"
        placeholder="Search instrument…"
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="w-full sm:w-64 px-3 py-2 text-sm rounded-md
                   bg-card border border-border text-white
                   placeholder:text-muted-foreground"
      />

      {/* Controls row */}
      <div className="flex flex-wrap gap-2 items-start">
        {/* Quick ranges */}
        {[
          { key: "today", label: "Today" },
          { key: "3d", label: "Last 3 Days" },
          { key: "7d", label: "Last Week" },
        ].map(opt => (
          <button
            key={opt.key}
            onClick={() => {
              setRange(opt.key);
              setCalendarRange(undefined);
              setStartDate("");
              setEndDate("");
              setCalendarOpen(false);
            }}
            className={`px-3 py-1.5 rounded-md text-xs font-medium border
              ${
                range === opt.key
                  ? "bg-orange-500 text-white border-orange-500"
                  : "bg-transparent text-muted-foreground border-border hover:text-white"
              }`}
          >
            {opt.label}
          </button>
        ))}

        {/* Calendar trigger */}
        <button
          onClick={() => setCalendarOpen(v => !v)}
          className="px-3 py-1.5 rounded-md text-xs font-medium border
                     bg-transparent text-muted-foreground border-border hover:text-white"
        >
          Select Date Range
        </button>

        {/* Calendar popup */}
        {calendarOpen && (
          <div className="relative">
            <div className="absolute z-50 mt-2">
              <Calendar
                mode="range"
                selected={calendarRange}
                onSelect={(rangeVal) => {
                  setCalendarRange(rangeVal);
                  setRange("custom");

                  if (rangeVal?.from) {
                    setStartDate(rangeVal.from.toISOString().slice(0, 10));
                  } else {
                    setStartDate("");
                  }

                  if (rangeVal?.to) {
                    setEndDate(rangeVal.to.toISOString().slice(0, 10));
                  } else {
                    setEndDate("");
                  }

                  // ✅ Close ONLY after full range selected
                  if (rangeVal?.from && rangeVal?.to) {
                    setCalendarOpen(false);
                  }
                }}
                numberOfMonths={1}
                className="rounded-xl border border-border bg-card shadow-xl"
              />

              {(startDate || endDate) && (
                <button
                  onClick={() => {
                    setCalendarRange(undefined);
                    setStartDate("");
                    setEndDate("");
                    setRange("today");
                    setCalendarOpen(false);
                  }}
                  className="mt-2 text-xs text-muted-foreground hover:text-white"
                >
                  Clear date range
                </button>
              )}
            </div>
          </div>
        )}

        {/* Group toggle */}
        <button
          onClick={() => setGroupBy(v => !v)}
          className={`px-3 py-1.5 rounded-md text-xs font-medium border
            ${
              groupBy
                ? "bg-emerald-600 text-white border-emerald-600"
                : "bg-transparent text-muted-foreground border-border hover:text-white"
            }`}
        >
          Group by Instrument
        </button>

        {/* Export */}
        <button
          onClick={() => exportTradesCSV(trades)}
          className="ml-auto px-3 py-1.5 rounded-md text-xs font-medium
                     bg-orange-500 text-white hover:bg-orange-600"
        >
          Export CSV
        </button>
      </div>
    </div>
  );
}
